module.exports = __webpack_public_path__ + "static/media/MBvision_chat.c7f9adec.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/MBvision_chat.mp4
// module id = 212
// module chunks = 0